module.exports = __webpack_public_path__ + "static/media/catering_image2.3427da55.png";